import React from 'react'
import { Container } from 'reactstrap'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import RhFichaPjPanel from './RhFichaPjPanel'

const RhFichaPjList = () => (
  <div className="page-content">
    <Container fluid>
      <Breadcrumbs
        title="Fichas PJ — Prestadores cadastrados"
        breadcrumbItems={[
          { title: 'RH', link: '/recursos-humanos/dashboard' },
        ]}
      />

      <RhFichaPjPanel />
    </Container>
  </div>
)

export default RhFichaPjList
